import { inject } from 'aurelia-framework';
import { NewInstance } from 'aurelia-dependency-injection';
import { ValidationController, validateTrigger, ValidationRules, ValidateBindingBehavior, ValidationRenderer } from 'aurelia-validation';
import { UserService } from '../Advertiser.SharedPortal/services/user-service';
import { LoggerService } from '../Advertiser.SharedPortal/services/logger-service';
import { StatusService } from '../Advertiser.SharedPortal/services/status-service';
import { MultiObserverService } from '../Advertiser.SharedPortal/services/multi-observer-service';
import { BrowserStorageService } from '../Advertiser.SharedPortal/services/browser-storage-service';


var config = require('../../config.js');
var safeStringify = require('fast-safe-stringify');

@inject(UserService, NewInstance.of(ValidationController), LoggerService, StatusService, MultiObserverService, BrowserStorageService)
export class ChangePassword {
   constructor(userService, controller, logger, status, multiObserver, browserStorage ) {
      this.userService = userService;
      this.controller = controller;
      this.logger = logger;
      this.controller.validateTrigger = validateTrigger.manual;
      this.status = status;
      this.multiObserver = multiObserver;
      this.browserStorage = browserStorage;

      this.oldPassword = '';
      this.newPassword = '';
      this.newPassword2 = '';
      this.errorMessage = '';
      this.submitted = false;
      this.email = '';
      this.myKeypressCallback = this.keypressInput.bind(this);
   }

   activate() {
      let that = this;
      this.configStatus();
      this.multiObserver.observe(this, ['oldPassword', 'newPassword', 'newPassword2'], function () { that.status.dirty(); });
      window.addEventListener('keypress', this.myKeypressCallback, false);
   }

   deactivate() {
      window.removeEventListener('keypress', this.myKeypressCallback);
   }

   keypressInput(e) {
      if (e.key === 'Enter') {
         this.onSubmit();
      }
   }

   configStatus() {
      // statuses:  dontchange, clean, dirty, working, loading, saving, success, error
      this.status.texts = ['', 'Change Password', 'Change Password', 'Changing Password', '', '', 'Changed Password', 'Error'];
      this.status.classes = ['', 'btn-disabled', 'btn-enabled', 'btn-processing', '', '', 'btn-success', 'btn-error'];
      this.status.clean();
   }

   onSubmit() {
      this.logger.debug('onSubmit() called');
      let that = this;

      let errors = this.controller.validate()
         .then((err) => {

            if (err.valid) {
               this.status.working();
               this.errorMessage = '';
               this.controller.reset();
               let token = this.browserStorage.getItem('AccessToken');
               this.email = this.browserStorage.getItem('email');
               this.userService.changePassword(token, this.oldPassword, this.newPassword, this.newPassword2)
                  .then(response => {
                     if (response && response[0] !== 'Success') {
                        that.errorMessage = "Your old password is incorrect. If you are new user or have forgotten your password please use the system generated password that was sent to you by email from Delty. Please re-enter.";
                        this.logger.debug(response);
                        that.submitted = false;
                        that.status.set(this.status.statuses.error, this.status.statuses.clean, config.buttonReset);
                     }
                     else {
                        that.errorMessage = '';
                        that.submitted = true;
                        that.status.set(this.status.statuses.success, this.status.statuses.clean, config.buttonReset);
                        that.userService.emailPasswordChangeConfirmation(this.email).then(response => {
                           if(response && response[0] !== 'Success'){
                              this.errorMessage = response;
                              this.submitted = true;
                              that.status.set(this.status.statuses.error, this.status.statuses.clean, config.buttonReset);
                           }else {
                              this.errorMessage = '';
                              this.submitted = true;
                              that.status.set(that.status.statuses.success, that.status.statuses.clean, config.buttonReset);
                           }
                        });
                        that.userService.redirectToPortal();
                     }
                  });
	    } else {
		console.log(safeStringify(err));
	    }
         });
   }
}

var passwordRegex = /(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[\^\$\*\.\[\]\{\}\(\)\?\-\"\!\@\#\%\&\/\,><':;|_~`]).{8,}/;
var passwordFormatMessage = 'Sorry, your {which} password is formatted incorrectly. Passwords must be at least 8 characters including one number, one upper, one lowercase letter, and a special character: ^ $ * . [ ] { } ( ) ? - " ! @ # % & / , > < \' : ; | _ ~ `'; 
var passwordMatchMessage = 'Sorry, your passwords don\'t match. Please re-enter your passwords.';

ValidationRules
   .ensure(p => p.oldPassword).required()
   .ensure(p => p.newPassword).required()
   .ensure(p => p.oldPassword).matches( passwordRegex ).withMessage( passwordFormatMessage.replace('{which}', 'old') ) 
   .ensure(p => p.newPassword).matches( passwordRegex ).withMessage( passwordFormatMessage.replace('{which}', 'new') )
   .ensure(p => p.newPassword2).required().withMessage('Re-entered Password is required')
   .ensure(p => p.newPassword2).satisfies((value, obj) => value === obj.newPassword).withMessage( passwordMatchMessage )
   .on(ChangePassword);
